import 'preact/debug'
// plugins
require("expose-loader?$!jquery");
import 'picturefill';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'Scripts/jquery.plugins'
import { SmoothScroll } from 'Scripts/jquery.plugins';
import Swiper from 'swiper';
import fancybox from '@fancyapps/fancybox';
import Masonry from 'masonry-layout';


// utils
import { getLocaleAndPathname } from "Scripts/utils";
import {formatMoney} from "@shopify/theme-currency/currency";
window.formatMoney = formatMoney;
// templates
import product from "Sections/product";
import 'Scripts/login'
import 'Scripts/addresses'

// sections
import { load } from '@shopify/theme-sections';
load('*');
import "Sections/related-product";
import "Sections/popup";
import "Sections/testimonials";
import "Sections/video";
import "Sections/slideshow";
import "Sections/product-carousel";
import "Sections/promo-carousel";
import "Sections/iframe-video";
import "Sections/vertical-gallery";
import "./Components/LiveSearch";
import "./Components/SearchForm";
import "./Components/CartReact";
import "./Components/CartCount";
import "./Components/CartPopup";
import Customizer from "./Components/Customizer";

window.formatMoney = formatMoney;

class App {
  constructor() {
    this.init();
  }
  
  
  init() {
    this.setHeaderHeight();
    this.initMobileNav();
    this.initPpdHeaderOnScroll();
    this.initIosScroll();
    this.initAccordion();
    this.initCurrencySwitcher();
    this.initLanguageSwitcher();
    this.initAnchors();
    this.initPromoCarousel();
    this.initOpenClose();
    this.initProductGallery();
    this.initTabs();
    this.pdpDescriptionContent();
    this.initInput();
    this.initBlogFilterLogic();
    this.initMasonry();
    this.initFancybox();
    this.initServicesForm();
    this.initProductCustomMade();

    // Responsive fluid iframe
    $(".rte iframe").each(function(index) {
      $(this).wrap('<div class="fluid-iframe"></div>');
    });

    if (!('ontouchstart' in document.documentElement)) {
      $('html').addClass('no-touch');
    }

    $(window).scroll(function(){
      if ($(this).scrollTop() > 0) {
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });
  }

  setHeaderHeight() {
    $(window).on('load resize scroll', function() {
      document.documentElement.style.setProperty('--header-height', $('#header').css('height'));
      document.documentElement.style.setProperty('--header-sticky-height', $('.header__panel').css('height'));
      document.documentElement.style.setProperty('--announcements-bar-height', $('.header__bar').css('height'));
      document.documentElement.style.setProperty('--pdp-header-height', $('.pdp-sticky-header').css('height'));
    })
  }

  // mobile menu init
  initMobileNav() {
    $('body').mobileNav({
      menuActiveClass: 'menu-active',
      menuOpener: '.menu__opener',
      menuDrop: '.menu',
      hideOnClickOutside: false
    });
  }

  initPpdHeaderOnScroll() {
    let didScroll;

    $(window).scroll(function(event) {
      didScroll = true;
    });

    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      let lastScrollTop = $(window).scrollTop();
      let headerHeight = $('#header').outerHeight();
      if (lastScrollTop <= headerHeight) {
        $('.pdp-sticky-header').removeClass('pdp-sticky-header--active');
      } else {
        $('.pdp-sticky-header').addClass('pdp-sticky-header--active');
      }
    }
  }

  initIosScroll() {
    ResponsiveHelper.addRange({
      '..1199': {
        on: function() {
          let $docEl = $('html, body'),
            $wrap = $('.page-wrapper'),
            scrollTop,
            scrolled;
          $(".page-wrapper__opener").on("click", function(e) {
            if ($('html').hasClass("scroll-fix")) {
              $.unlockBody();
              $('html').removeClass("scroll-fix");
            } else {
              $.lockBody();
              $('html').addClass("scroll-fix");
            }
          });
          $(window).on("scroll", function() {
            if (scrolled) $('body').addClass('menu-fixed-position');
            else $('body').removeClass('menu-fixed-position');
          });
          $.unlockBody = function() {
            $docEl.css({
              height: "",
              overflow: ""
            });
            $wrap.css({
              top: ''
            });
            window.scrollTo(0, scrollTop);
            window.setTimeout(function() {
              scrollTop = null;
              scrolled = false;
            }, 0);
          };
          $.lockBody = function() {
            if (window.pageYOffset) {
              scrollTop = window.pageYOffset;
              scrolled = true;
              $wrap.css({
                top: -(scrollTop)
              });
            }
            $docEl.css({
              height: "100%",
              overflow: "hidden"
            });
          };
        },
        off: function() {
          $(".page-wrapper__opener").off();
        }
      }
    });
  }

  // accordion menu init
  initAccordion() {
    ResponsiveHelper.addRange({
      '..1199': {
        on: function() {
          $('.menu-accordion').slideAccordion({
            activeClass: 'active',
            opener: '.menu-accordion__opener',
            slider: '.menu-accordion__slide',
            collapsible: true,
            event: 'click',
            animSpeed: 400
          });
        },
        off: function() {
          $('.menu-accordion').slideAccordion('destroy');
        }
      }
    });
    $('.product-accordion').slideAccordion({
      opener: '.product-accordion__opener',
      slider: '.product-accordion__slide',
      collapsible: true,
      animSpeed: 300,
      addClassBeforeAnimation: true,
    });
    $('.benefits-accordion').slideAccordion({
      opener: '.benefits-accordion__opener',
      slider: '.benefits-accordion__slide',
      animSpeed: 300,
      addClassBeforeAnimation: true,
    });
  }

  initCurrencySwitcher() {
    function currencyFormSubmit(event) {
      event.target.form.submit();
    }
    let currencySwitchers = document.querySelectorAll('.shopify-currency-form select');
    if (currencySwitchers.length) {
      currencySwitchers.forEach(el => el.addEventListener('change', currencyFormSubmit))
    }
  }
  
  initLanguageSwitcher() {
    const [curLocale, pathname] = getLocaleAndPathname(theme.published_locales);
    let languageSwitchers = document.querySelectorAll('[name="locales"]');
    if (languageSwitchers.length) {
      languageSwitchers.forEach(el => el.addEventListener('change', (e) => {
        let selectedLocale = e.target.value;
        console.log('selectedLocale', selectedLocale)
        console.log('pathname', pathname)
        location.href = selectedLocale === '/' ? pathname : selectedLocale + pathname;
      }))
    }
  }

  initAnchors() {
    new SmoothScroll({
      anchorLinks: '.anchor-link',
      activeClasses: 'active',
      wheelBehavior: 'none',
      extraOffset: $('.header__panel').height() || 0,
      animDuration: 800,
    });
  }

  initPromoCarousel() {
    let promoCarousel = undefined;

    function initPromoSwiper() {
      let screenWidth = $(window).width();
        if(screenWidth < 1199 && promoCarousel == undefined) {
          promoCarousel = new Swiper('.promo-carousel', {
            spaceBetween: 11,
            slidesPerView: '1.244',
            watchOverflow: true,
            loop: false,
            speed: 800,
            scrollbar: {
              el: '.swiper-scrollbar',
              hide: false,
            },
          });
        } else if (screenWidth > 1200 && promoCarousel != undefined) {
          promoCarousel.destroy();
          promoCarousel = undefined;
        }
    }

    //Swiper plugin initialization
    initPromoSwiper();

    //Swiper plugin initialization on window resize
    $(window).on('resize', function(){
      initPromoSwiper();
    });
  }

  initOpenClose() {
    ResponsiveHelper.addRange({
      '..1199': {
        on: function() {
          $('.footer-open-close').openClose({
            activeClass: 'footer-open-close--active',
            opener: '.footer-open-close__opener',
            slider: '.footer-open-close__slide',
            animSpeed: 300,
            effect: 'slide',
          });
        },
        off: function() {
          $('.footer-open-close').openClose('destroy');
        }
      }
    });

    $('.sort-open-close').openClose({
      activeClass: 'sort-open-close--active',
      opener: '.sort-open-close__opener',
      slider: '.sort-open-close__slide',
      animSpeed: 0,
      effect: 'none',
      hideOnClickOutside: true
    });

    ResponsiveHelper.addRange({
      '..1199': {
        on: function() {
          $('.search-open-close').openClose({
            activeClass: 'search-open-close--active',
            opener: '.search-open-close__opener',
            slider: '.search-open-close__slide',
            animSpeed: 400,
            effect: 'slide',
            hideOnClickOutside: false
          });
        },
        off: function() {
          // $('.search-open-close').openClose('destroy');
        }
      }
    });

    ResponsiveHelper.addRange({
      '1200..': {
        on: function() {
          $('.search-open-close').openClose({
            activeClass: 'search-open-close--active',
            opener: '.search-open-close__opener',
            slider: '.search-open-close__slide',
            animSpeed: 400,
            effect: 'fade',
            hideOnClickOutside: false
          });
        },
        off: function() {
          // $('.search-open-close').openClose('destroy');
        }
      }
    });

    $('.search-open-close__opener').on('click', function(e) {
      document.documentElement.style.setProperty('--header-height', $('#header').css('height'));
      document.documentElement.style.setProperty('--header-sticky-height', $('.header__panel').css('height'));
    });
  }
  
  initProductGallery() {
    var productGalleryThumbs = new Swiper('.product-gallery-thumbs', {
      spaceBetween: 11,
      direction: 'vertical',
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      speed: 800,
      watchOverflow: true,
    });
    var productGallery  = new Swiper('.product-gallery', {
      slidesPerView: 1.25,
      spaceBetween: 12,
      speed: 800,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          slidesPerView: 1,
          spaceBetween: 110,
        },
      },
      thumbs: {
        swiper: productGalleryThumbs
      },
    });
  }

  initTabs() {
    $('.custom-made-section__tabset').tabset({
      tabLinks: 'a',
      autoHeight: false,
      addToParent: true,
      attrib: 'data-tab',
      checkHash: false,
      defaultTab: true
    });
  }

  pdpDescriptionContent() {
    $('.js-pdp-description').each(function() {
      const $this = $(this);
      const expandButton = $this.find('.js-pdp-description-btn');
      const textElem = $($this).find('span');
      const text = textElem.text();
      const ellipcisText = text.substring(0, 152) + '…';
      const readMore = 'Read More';
      const readLess = 'Read Less';

      textElem.text(ellipcisText);
      expandButton.text(readMore);
      expandButton.on('click', function(e) {
        e.preventDefault();
        if ($this.hasClass('open')) {
          // close
          $this.removeClass('open');
          $this.slideUp(600, function () {
            textElem.text(ellipcisText);
            expandButton.text(readMore);
            $this.css ({
              display: 'block',
              minHeight: 0,
            });
          });
        } else {
          // open
          $this.css ({
            minHeight: textElem.height() + 5 + 'px',
            display: 'none',
          });
          textElem.text(text);
          expandButton.text(readLess);
          $this.addClass('open');
          $this.slideDown(600);
        }
      });
    });
  }

  initInput() {
    var defaultVal = '';
    var $input = $('.input-row input');
    var $textarea = $('.input-row textarea');
    $input.focus(function(event) {
        $(this).closest('.input-row').addClass('focus');
    });
    $textarea.focus(function(event) {
        $(this).closest('.input-row').addClass('focus');
    });
    $input.blur(function(event) {
        $(this).closest('.input-row').removeClass('focus');
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
    });
    $textarea.blur(function(event) {
        $(this).closest('.input-row').removeClass('focus');
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
    });
    $input.keyup(function(event) {
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
    });
    $textarea.keyup(function(event) {
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
    });
    $input.change(function(event) {
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
        $(this).blur();
    });
    $textarea.change(function(event) {
        var actionVal = $(this).val();
        if (actionVal !== defaultVal) $(this).closest('.input-row').addClass('enter');
        else $(this).closest('.input-row').removeClass('enter');
        $(this).blur();
    });
    $textarea.each(function() {
        if ($(this).val() !== '') $(this).closest('.input-row').addClass('enter');
        if ($(this).is(':disabled')) $(this).closest('.input-row').addClass('disable');
    });
  }

  initCustomScroll() {
    window.$scrollPane = $('.scroll-pane');
    window.jScrollPane = $.jScrollPane;
    ResponsiveHelper.addRange({
      '1200..': {
        on: function () {
            // this need because error will be generated
            // when no element found in template
            if ($scrollPane.length) {
                $scrollPane.jScrollPane(
                  {
                    autoReinitialise: true
                  }
                );
            }
        },
        off: function () {
            // this need because error will be generated
            // when no element found in template
            if ($scrollPane.length) {
                $scrollPane.jScrollPane('destroy');
            }
        }
      }
    });
  }

  initOpenMiniCart() {
    $('.header__cart-btn').on('click', function(e) {
      e.preventDefault();
      $('.cart-popup').toggleClass('active');
      $('body').toggleClass('mini-cart--active');
    })
  }
  
  initBlogFilterLogic() {
    const wrapper = $('#blog-filter-js');
    const sortedBy = wrapper.find('.sort-open-close__btn-opener span');
    const filterItems = wrapper.find('ul li');
    
    filterItems.each((index, item) => {
      if ($(item).hasClass("active")) {
        let activeText = $(item).text();
        sortedBy.text(activeText);
      }
    })
  }

  initMasonry() {
    $(window).on('load', function() {
      const grid = document.querySelector('.instagram-section__grid');
      if (grid) {
        const masonry = new Masonry(grid, {
          itemSelector: '.instagram-section__grid-item',
          columnWidth: '.instagram-section__grid-sizer',
          percentPosition: true
        });
      }
    })
  }

  initFancybox() {
    $('[data-fancybox-instagram]').fancybox({
      parentEl: 'body',
      baseClass: "fancybox-instagram-details",
      margin: [50, 5],
      autoFocus: false,
      closeExisting: true,
      toolbar: false,
      touch: false
    });
  }
  
  initServicesForm() {
    const form = $('.js-services-form');
    const formJS = document.querySelector('.js-services-form')
    const formSection = $(".js-form-section");
    const successFormSection = $(".js-success-form-section");
    customCheckValidity()
    
    function customCheckValidity() {
      form.validate({
        highlight: function(element) {
          $(element).parent().addClass("input-error");
        },
        unhighlight: function(element) {
          $(element).parent().removeClass("input-error");
        },
        errorPlacement: function(error, element) {
          $(element).next().html(error)
        }
      })
    }

    form.submit((e) => {
      if (form.valid()) {
        e.preventDefault();
        $.post('https://submit.jotform.com/submit/210242848544051/', form.serialize(), (res) => {
          console.log('res', res)
        }).
        done((res) => {
          console.log(res);
          formSection.addClass('d-none');
          successFormSection.removeClass('d-none')
        })
      } else {
        e.preventDefault();
      }
    })
  }
  
  initProductCustomMade() {
    const wrapper = document.getElementById('custom-made-section');
    if (!wrapper) { return false };
    window.onload = () => {
      const lists = wrapper.querySelectorAll('.custom-made-section__list li');
      function getCustomMadeClass(data) {
        const aBlockId = (data).attr('data-block-id');
        return `custom-made-section--bg-${aBlockId}`;;
      }
     
      lists.forEach((elem, index) => {
        if ($(elem).hasClass('active')) {
          const customMadeBgClass = getCustomMadeClass($(elem).find('.custom-made-section__link'));
          wrapper.classList.add(customMadeBgClass);
        }
        $(elem).on('click', (e) => {
          wrapper.className = 'section section--light custom-made-section';
          const customMadeBgClass = getCustomMadeClass($(e.target.closest('.custom-made-section__link')));
          $(wrapper).addClass(customMadeBgClass);
        })
      })
    }
  }
}

const app = new App();


